
  import { Vue, Component, Prop,Watch } from 'vue-property-decorator'
  import { getCookie, mul } from '../../utils/publish'
  import { UserModule } from '@/store/modules/user'
  @Component
  export default class StudentData extends Vue {
    @Prop() is_index_change

    start_time: string = ''
    end_time: string = ''
    tableData: any = []
    headerData: any = []
    instrumentTypes: any = []
    teacherType: any = []
    campusType: any = []
    time: any = []
    source: any = []
    ages: any = []
    totalData: any = []
    height: any = window.innerHeight - 180
    loading: boolean = true

    @Watch('is_index_change')
    getChange(newVal,oldVal) {
      if(newVal) {
        this.getCookieData()
        this.getTeachList('')
        this.getTeachList(1)
      }
    }

    async getTeachList(val) {
      const res = await UserModule.teachList({ is_total: val, data_type: 1, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.teacherType.toString(), start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString()})
      if (val) {
        this.totalData = res.data
      } else {
        this.tableData = res.data
        this.loading = false
      }
      this.$emit('get-data', false)
    }
    getMul(val1, val2) {
      return mul(val1, val2)
    }
    handleCellClick(row, column, cell, event) {
      const label = column.label
      const property = column.property
      const employee_id = row.employee_id
      if (label !== '人员') {
        if (row.is_total) {
          this.$router.push({ path: '/dashboard/teacher', query: { employee_id: '', property: property } })
        } else {
          this.$router.push({ path: '/dashboard/teacher', query: { employee_id: employee_id, property: property } })
        }
      }
    }

    getCookieData() {
      this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
      this.teacherType = JSON.parse(getCookie('teacherType'))
      this.campusType = JSON.parse(getCookie('campusType'))
      this.source = JSON.parse(getCookie('source')) 
      this.ages = JSON.parse(getCookie('ages'))
      this.time = JSON.parse(getCookie('time'))
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
    }

    mounted(){
      this.getCookieData()
      this.getTeachList('')
      this.getTeachList(1)
    }
  }
